import { Component } from '@angular/core';

import { FieldBaseComponent } from '@shared/components/forms/components/field-base';
import { FormFieldErrorComponent } from '@shared/components/forms/components/form-field-error/form-field-error.component';

import { NgClass } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-form-input-group',
  styleUrls: ['form-input-group.component.scss'],
  templateUrl: 'form-input-group.component.html',
  imports: [FormsModule, ReactiveFormsModule, FormFieldErrorComponent, NgClass],
})
export class FormInputGroupComponent extends FieldBaseComponent {}
